
<div class="container">
  <h2>Same Effort, Better Result</h2>
  <div class="row">
    <div class="col-md-9">
      View in: <button class="btn btn-dark-blue right-10px" id="percentage-control" (click)="barchart.setTextFormat('percent')">percentage</button>
      <button class="btn btn-dark-blue right-10px" id="claims-control" (click)="barchart.setTextFormat('number')"># claims</button>
      <button class="btn btn-dark-blue right-10px" id="dollars-control" (click)="barchart.setTextFormat('dollars')">dollars</button>
    </div>
    <div class="col-md-3">
      <button class="btn btn-light-gray" id="replay" (click)="play()">Replay</button>
    </div>
  </div>
  <div id="barchart"></div>
  <div id="progress-bar"></div>
</div>
